import React from 'react'
import { AuthDialogComponent } from './AuthDialogComponent'
import { Button } from '@mui/material'
import EnterIcon from '@mui/icons-material/TransitEnterexit'

interface IOpenAuthDialogButton {
  school: any
  buttonTextComponent?: React.ReactNode
  buttonVariant?: 'text' | 'outlined' | 'contained'
  onAuthDialogOpenStateChange?: (isOpen: boolean, isCancel?: boolean) => void
}

export default function OpenAuthDialogButton(props: IOpenAuthDialogButton) {
  const [openAuthDialog, setOpenAuthDialog] = React.useState(false)

  function toggleOpenAuthDialog(shouldOpen?: boolean, isCancel?: boolean) {
    if (shouldOpen) {
      setOpenAuthDialog(shouldOpen)
      props.onAuthDialogOpenStateChange?.(shouldOpen, isCancel)
    } else {
      setOpenAuthDialog(!openAuthDialog)
      props.onAuthDialogOpenStateChange?.(!openAuthDialog, isCancel)
    }
  }

  return (
    <>
      <Button
        style={{ height: '50px' }}
        color="primary"
        disableElevation={true}
        size="large"
        fullWidth={true}
        variant={props.buttonVariant || 'contained'}
        onClick={() => {
          toggleOpenAuthDialog(true)
        }}
      >
        {props.buttonTextComponent || (
          <>
            {' '}
            <EnterIcon style={{ marginRight: '5px' }} /> Click to login/register
            to school
          </>
        )}
      </Button>
      <AuthDialogComponent
        school_details={props.school}
        openAuthDialog={openAuthDialog}
        closeAuthDialogFunction={isCancel => {
          toggleOpenAuthDialog(false, isCancel)
        }}
      />
    </>
  )
}
